import { Navigate } from "react-router-dom";
import { getCookieValue } from "../../redux/store";

export const PrivateRoute = ({ children }) => (getCookieValue("password") ? children : <Navigate to="/"></Navigate>);
